var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hoursStatusMap, shiftParticipantEntityName, } from '../../../../backend/features/shift/shared';
import { getTimeString } from '../../../../backend/utils/getTimeString';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { exportToCsv } from '../../../../ui/utils/exportToCsv';
import { stringifyCsvFileToDataUrl } from '@juvare/data-import-ui/CsvFile';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Button, FormControl, IconButton, MenuItem, Select } from '@mui/material';
import React from 'react';
import { allDateRanges, allStatuses } from '../constants';
import { timeTrackingDateRanges, timeTrackingHoursStatuses } from '../types';
import { DeleteVolunteeringHours } from './DeleteVolunteeringHours';
export const TimeTrackingPageToolbar = ({ selectedRowIds, disableDelete, onDeleteHours, onFilterChange, onClearFilters, }) => {
    const { t } = useMissionsTranslation();
    const [selectedDateRangeFilter, setSelectedDateRangeFilter] = React.useState(allDateRanges);
    const [selectedStatusFilter, setSelectedStatusFilter] = React.useState(allStatuses);
    const shiftParticipationStorage = useStorageClient(shiftParticipantEntityName);
    const shiftParticipantHoursExportHeader = [
        'Shift Date',
        'Mission Name',
        'Shift Location',
        'Mission Type',
        'Position',
        'Shift Start Time',
        'Shift Stop Time',
        'Hours',
        'Volunteer Shift Status',
    ];
    const mapDataToCsvRow = (data) => {
        return [
            t('dateString', { value: data.columns.shiftStartTime }),
            data.columns.missionName,
            data.columns.shiftLocation,
            data.columns.missionType,
            data.columns.positionName,
            t('time', { value: data.columns.shiftStartTime }),
            t('time', { value: data.columns.shiftStopTime }),
            data.columns.hours ? t(`time`, { value: getTimeString(data.columns.hours) }) : t('timeTracking.missingHoursTable'),
            hoursStatusMap[data.columns.hoursStatus],
        ];
    };
    const exportCsv = () => __awaiter(void 0, void 0, void 0, function* () {
        const csvFile = {
            header: shiftParticipantHoursExportHeader,
            rows: [],
        };
        for (const id of selectedRowIds) {
            const response = yield shiftParticipationStorage.get(id);
            csvFile.rows.push(mapDataToCsvRow(response));
        }
        return stringifyCsvFileToDataUrl(csvFile);
    });
    const handleExportCsv = () => exportToCsv(exportCsv, 'participation_hours', t);
    const clearAllFilters = () => {
        setSelectedDateRangeFilter(allDateRanges);
        setSelectedStatusFilter(allStatuses);
        onClearFilters();
    };
    return (React.createElement(Box, { sx: [{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, pb: 2 }] },
        React.createElement(Box, { sx: {
                display: 'flex',
                gap: 1,
                alignItems: 'center',
                flexDirection: { sm: 'column', md: 'row' },
                width: { sm: '100%', md: 'auto' },
            } },
            React.createElement(FormControl, { sx: {
                    minWidth: {
                        lg: 280,
                    },
                }, size: 'small', fullWidth: true },
                React.createElement(Select, { value: selectedDateRangeFilter, "data-test": 'filter-date-range', onChange: (e) => {
                        setSelectedDateRangeFilter(e.target.value);
                        onFilterChange('shiftStartTime', e.target.value);
                    }, inputProps: {
                        'data-testid': 'filter-date-range',
                    } }, timeTrackingDateRanges.map((dateRange) => (React.createElement(MenuItem, { value: dateRange, key: dateRange }, t(`timeTracking.toolbar.dateRange.${dateRange}`)))))),
            React.createElement(FormControl, { sx: {
                    minWidth: {
                        lg: 280,
                    },
                }, size: 'small', fullWidth: true },
                React.createElement(Select, { value: selectedStatusFilter, "data-test": 'filter-hour-status', onChange: (e) => {
                        setSelectedStatusFilter(e.target.value);
                        onFilterChange('hoursStatus', e.target.value);
                    }, inputProps: {
                        'data-testid': 'filter-hour-status',
                    } }, timeTrackingHoursStatuses.map((status) => (React.createElement(MenuItem, { key: status, value: status }, t(`timeTracking.toolbar.status.${status}`)))))),
            React.createElement(IconButton, { onClick: clearAllFilters, "aria-label": t('ariaLabels.clearFilters'), "data-test": 'clear-filters-button' },
                React.createElement(ReplayIcon, { color: 'primary' }))),
        React.createElement(Box, { sx: [
                {
                    display: 'flex',
                    flexGrow: 3,
                    justifyContent: 'flex-end',
                    gap: 2,
                    flexDirection: { xs: 'column', sm: 'row' },
                    width: { xs: '100%', md: 'auto' },
                },
            ] },
            React.createElement(DeleteVolunteeringHours, { selectedRowIds: selectedRowIds, disableDelete: disableDelete, onDeleteHours: onDeleteHours }),
            React.createElement(Button, { sx: { width: { xs: '100%', md: 'auto' } }, variant: 'contained', size: 'large', onClick: () => handleExportCsv(), disabled: selectedRowIds.length === 0, "data-test": 'export-button' }, t('common.exportCsv')))));
};
